import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=b5875a6c&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=ts"
export * from "./user-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5875a6c",
  null
  
)

export default component.exports